import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate, useParams } from 'react-router'

import {
  TextMaterialCategory,
  useTextMaterialCategories,
} from '@entities/Blog'
import { useBlogTextMaterials } from '@entities/Blog/hooks/useAllTextMaterials'


import { BannerApp } from '@widgets/app-banner'
import { BlogList } from '@widgets/blog-list'





import SEO from '@shared/components/SEO'
import { URL_BLOG, URL_BLOG_CATEGORY } from '@shared/contants'
import { BRAND_NAME } from '@shared/contants/app'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function BlogPage () {
  const { t: tb } = useTranslation('blog')
  const { t } = useTranslation('seo')

  const { categorySlug, themeSlug, tagSlug } = useParams()
  const navigate = useNavigate()

  const { textMaterials } = useBlogTextMaterials({
    categorySlug,
    themeSlug,
    tagSlug,
  })

  const { textMaterialCategories } = useTextMaterialCategories()

  const handleCategoryClick = (category?: TextMaterialCategory) => {
    if (!category) {
      navigate(URL_BLOG)
      return
    }
    const categoryUrl = generatePath(URL_BLOG_CATEGORY, {
      categorySlug: category.slug,
    })
    navigate(categoryUrl)
  }

  const selectedCategory = textMaterialCategories.find(
    (category) => category.slug === categorySlug,
  )

  return (
    <Container>
      <SEO
        title={t('blog.title', { brand: BRAND_NAME })}
        description={t('blog.description', { brand: BRAND_NAME })}
      />
      <PageGrid>
        <Wrapper className={styles.wrapper}>
          <Breadcrumbs
            className={styles.breadcrumbs}
            links={[
              {
                title: tb('blog'),
              },
              ...(selectedCategory?.title && selectedCategory.slug
                ? [
                  {
                    title: selectedCategory.title,
                    to: generatePath(URL_BLOG_CATEGORY, {
                      categorySlug: selectedCategory.slug,
                    }),
                  },
                ]
                : []),
              ...(themeSlug
                ? [
                  {
                    title: themeSlug,
                    to: generatePath(URL_BLOG_CATEGORY, {
                      categorySlug: themeSlug,
                    }),
                  },
                ]
                : []),
              ...(tagSlug
                ? [
                  {
                    title: tagSlug,
                    to: generatePath(URL_BLOG_CATEGORY, {
                      categorySlug: tagSlug,
                    }),
                  },
                ]
                : []),
            ]}
          />

          <BlogList
            currentCategorySlug={categorySlug}
            showCategories={!themeSlug && !tagSlug}
            articles={textMaterials}
            categories={textMaterialCategories}
            onCategoryChange={handleCategoryClick}
          />
          <BannerApp />
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
